<template>
    <ShortcutsOverview
        :show="open"
        :groups="groups"
        :heading="t('keymap_title')"
        :close-label="t('keymap_close')"
        @close="open = false"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBuilderT } from '@src/Common/Builder/host';
import { isMac, mod } from '@src/Common/Builder/shortcutKeys';
import ShortcutsOverview, { type ShortcutsGroup } from '@src/Common/Components/UI/ShortcutsOverview.vue';

const t = useBuilderT();

const open = defineModel<boolean>({ required: true });

const key = (suffix: string): string => t(`${suffix}`);

const groups = computed<ShortcutsGroup[]>(() => [
    {
        title: key('keymap_group_global'),
        rows: [
            { keys: [`${mod} K`], label: key('command_palette') },
            { keys: ['?'], label: key('keymap_keymap') },
            { keys: ['Esc'], label: key('keymap_deselect') },
        ],
    },
    {
        title: key('keymap_group_blocks'),
        rows: [
            { keys: [`${mod} Z`], label: key('undo') },
            { keys: [isMac ? '⇧ ⌘ Z' : 'Ctrl Shift Z'], label: key('redo') },
            { keys: [`${mod} D`], label: key('duplicate') },
            { keys: ['Del'], label: key('delete') },
        ],
    },
    {
        title: key('keymap_group_inline'),
        rows: [
            { keys: ['2×'], label: key('keymap_inline_start') },
            { keys: ['Enter', `${mod} Enter`], label: key('keymap_inline_commit') },
            { keys: ['Esc'], label: key('keymap_inline_cancel') },
        ],
    },
    {
        title: key('keymap_group_palette'),
        rows: [
            { keys: ['↑', '↓'], label: key('keymap_palette_move') },
            { keys: ['Enter'], label: key('keymap_palette_run') },
            { keys: ['Esc'], label: key('keymap_close') },
        ],
    },
]);
</script>
